import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=e7eb26ea&scoped=true&"
import script from "./Discussion.vue?vue&type=script&lang=js&"
export * from "./Discussion.vue?vue&type=script&lang=js&"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=e7eb26ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7eb26ea",
  null
  
)

export default component.exports